export interface MenuItem {
  title: string;
  url: string;
  description?: string;
  icon?: React.ReactNode;
  items?: MenuItem[];
  external?: boolean;
  prefetch?: boolean;
}

// This is the content for the header, that lives in either the desktop or mobile header
export const headerMenu: MenuItem[] = [
  {
    title: "Playground",
    url: "/me/playground",
    prefetch: true,
  },
  {
    title: "Docs",
    url: "https://docs.moondream.ai",
    external: false,
  },
  {
    title: "Blog",
    url: "/blog",
    prefetch: true,
  },
  {
    title: "Pricing",
    url: "/pricing",
    prefetch: true,
  },
  /*  An example of a nested menu item
    {
      title: "Products",
      url: "#",
      items: [
        {
          title: "Blog",
          description: "The latest industry news, updates, and info",
          icon: <Book className="size-5 shrink-0" />,
          url: "#",
        },
        {
          title: "Company",
          description: "Our mission is to innovate and empower the world",
          icon: <Trees className="size-5 shrink-0" />,
          url: "#",
        },
      ],
    },
  ] ,
  */
];

export const userMenu: MenuItem[] = [
  {
    title: "API Keys",
    url: "/me/api-keys",
  },
  {
    title: "Playground",
    url: "/me/playground",
  },
];
